module.exports = __webpack_public_path__ + "static/media/02_hero_tablet.8e58c2aa.jpg";